import React from 'react';
import UserProfile from '../components/UserProfile';

const Profile = () => (
  <>
    <UserProfile />
  </>
);

export default Profile;
